import { useCallback, useContext, useEffect, useState } from 'react';
import useOffer from '../../api/hooks/useOffers';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { Offer } from '../../interfaces';
import { filterByName } from '../../utils/filters/offerFilter';
import OfferCard from './OfferCard';
import { apiURL, domain } from '../../consts/URLs';
import Loader from '../Loader';
import OfferPopover from './OfferPopover';
import { PRODUCT } from '../../api/endpointList';
import Textarea from '@mui/joy/Textarea';
import CustomInput from '../inputs/CustomInput';
import FastEditRow from '../models/FastEditRow';
import { off } from 'process';
import { possible_statuses } from '../../consts/possible_statuses';
import CustomModal from '../modals/CustomModal';
import SimpleImageSlider from 'react-simple-image-slider';


const OffersTable = (props: any) => {
    const { isMobile } = useIsMobile();

    const { token, refresh, user } = useContext(MainContext);
    const { RESPONSES, RESULTS, CTAs } = useOffer();
    const [categories, setCategories] = useState<any>([]);
    const [conditions, setConditions] = useState<any>([]);


    const [products, setProducts] = useState<any>([]);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [fastEdit, setFastEdit] = useState<boolean>(false);
    const [totalProducts, setTotalProducts] = useState<number>(0);
    const [detailedImages, setDetailedImages] = useState<any>([]);

    const [popupImages, setPopupImages] = useState<boolean>(false);

    const [selectAll, setSelectAll] = useState<boolean>(false);

    useEffect(() => {
        const queryParam = new URLSearchParams(window.location.search);
        if (queryParam.has('page')) {
            setPage(Number(queryParam.get('page')));
        }
    }, []);


    useEffect(() => {
        if (props.conditions) {
            setConditions(props.conditions);
        }

        if (props.categories) {
            setCategories(props.categories);
        }

    }, []);


    const getPages = () => {
        const pages = [];
        const startPage = Math.max(1, page - 4);
        const endPage = Math.min(totalPages, page + 4);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    const [isLoading, setIsLoading] = useState(false);

    const goToPage = async (page: number) => {
        try {
            setIsLoading(true);
            setPage(page);

            const keyword = props.obj && props.obj.name && props.obj.name !== '' ? `keyword=${encodeURI(props.obj.name)}` : '';
            const published = props.obj && props.obj.published !== null && props.obj.published !== -1 && props.obj.published !== 'null' ? `&published=${props.obj.published}` : '';
            const condition = props.obj && props.obj.conditionId && props.obj.conditionId !== 'null' && props.obj.conditionId !== -1 ? `&condition_id=${props.obj.conditionId}` : '';
            const category = props.obj && props.obj.categoryId && props.obj.categoryId !== 'null' && props.obj.categoryId !== -1 ? `&category_id=${props.obj.categoryId}` : '';
            const vendor = props.obj && props.obj.vendorId != null && props.obj.vendorId !== 'null' && props.obj.vendorId !== -1 ? `&vendor_id=${props.obj.vendorId}` : '';
            const brand = props.obj && props.obj.brand && props.obj.brand !== 'null' && props.obj.brand !== '' ? `&brand=${props.obj.published}` : '';
            const price_order = props.obj && props.obj.price_order && props.obj.price_order !== 'null' && (props.obj.price_order === 'asc' || props.obj.price_order === 'desc') ? `&price_order=${props.obj.price_order}` : '';
            const errors = props.obj && props.obj.errors && props.obj.errors !== 'null' && props.obj.errors !== -1 ? `&errors=${props.obj.errors}` : '';
            const products_per_page = props.obj && props.obj.products_per_page && props.obj.products_per_page !== 'null' ? `&products_per_page=${props.obj.products_per_page}` : '';
            const quantity = props.obj && props.obj.quantity != null && props.obj.quantity !== '' && !isNaN(Number(props.obj.quantity)) ? `&quantity=${props.obj.quantity}` : '';
            const quantity_min = props.obj && props.obj.quantity_min != null && props.obj.quantity_min !== '' && !isNaN(Number(props.obj.quantity_min)) ? `&quantity_min=${props.obj.quantity_min}` : '';
            const quantity_max = props.obj && props.obj.quantity_max != null && props.obj.quantity_max !== '' && !isNaN(Number(props.obj.quantity_max)) ? `&quantity_max=${props.obj.quantity_max}` : '';
            const endpoint = `${apiURL}/search/products?page=${page}&${keyword + published + condition + category + vendor + brand + price_order + errors + products_per_page + quantity + quantity_min + quantity_max}`;

            const header = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8',
                },
            };

            const response = await fetch(endpoint, header);

            if (response.ok) {
                const json = await response.json();
                setTotalPages(json.last_page);
                setTotalProducts(json.total);
                setProducts(json);
            }
            setIsLoading(false);
        } catch (e) {
            console.error(e);
            setIsLoading(false);
        }
    };

    const getSearchedProducts = async (queryParams: string) => {
        setIsLoading(false);
        const url = `${apiURL}/search/${PRODUCT}?${queryParams}`;

        const header = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8',
            },
        };

        const response = await fetch(url, header);

        if (response.ok) {
            const json = await response.json();
            setTotalPages(json.last_page);
            setTotalProducts(json.total);
            setProducts(json);

        }
        setIsLoading(false);
    };

    useEffect(() => {
        // if (props.offerOnSearchName.name === '' || !props.offerOnSearchName.name) {
        setIsLoading(true);

        const queryParam = new URLSearchParams(window.location.search);

        if (queryParam) {
            getSearchedProducts(queryParam.toString());
        } else {
            CTAs.filterProducts();
        }
        // }
        // if (props.offerOnSearchName && props.offerOnSearchName.name.trim().length > 0 && props.offerOnSearchName.name.trim()?.length % 3 === 0) {
        //     setIsLoading(true);
        //     CTAs.filterProducts({
        //         keyword: props.offerOnSearchName.name,
        //         published: props.offerOnSearchName.published,
        //         conditionId: props.offerOnSearchName.conditionId,
        //     });
        // }
    }, [refresh]);

    useEffect(() => {
        setIsLoading(true);
        if (props.searchedProducts) {
            setPage(1);
            setProducts(props.searchedProducts);
            setTotalPages(props.searchedProducts.last_page);
            setTotalProducts(props.searchedProducts.total);
        }
        setIsLoading(false);
    }, [props.searchedProducts, props.isLoading]);

    useEffect(() => {
        if (RESPONSES.filterProductsResponse?.ok) {
            setProducts(RESULTS.filterProductsResult);
        }
        setIsLoading(false);
    }, [RESPONSES.filterProductsResponse, RESULTS.filterProductsResult]);

    useEffect(() =>{
        if(props.updateTable){
            goToPage(page);
            props.setUpdateTable(false);
        }
        
    },[props.updateTable]);

    // useEffect(() => {
    //     // console.log(RESPONSES.filterProductsResponse);

    //     if (RESPONSES.filterProductsResponse?.ok) {
    //         setProducts(RESULTS.filterProductsResult);
    //         setIsLoading(false);
    //     }
    // }, [RESPONSES.filterProductsResponse, RESULTS.filterProductsResult]);

    // useEffect(() => {
    //     if (offersDisplayed.length < offersFiltered.length) {
    //         setIsToggled(false);
    //     } else if (offersDisplayed.length === offersFiltered.length) {
    //         setIsToggled(true);
    //     }
    // }, [offersDisplayed]);

    // useEffect(() => {
    //     if (offersFiltered) {
    //         const offersOnDisplay = offersFiltered; /* .slice(
    //     0,
    //     offersPerLoad * props.loadMoreCounter
    //   ); */
    //         setOffersDisplayed(offersOnDisplay);
    //     }
    // }, [offersFiltered /* , props.loadMoreCounter */]);

    // useEffect(() => {
    //     if (offersFetched) {
    //         setOffersFiltered(offersFetched);
    //     }
    // }, [offersFetched]);

    // useEffect(() => {
    //     /* console.log(
    //   RESPONSES.getOffersListAllResponse,
    //   RESULTS.getOffersListAllResult
    // ); */

    // }, []);

    const showDetailedImages = (images: any) => {
        setDetailedImages(images);
        setPopupImages(true);
    };

    const closeDetailedImages = () => {
        setDetailedImages([]);
        setPopupImages(false);
    }

    const onPressNext = useCallback(async () => {
        try {
            setIsLoading(true);
            let newPage = page + 1;
            setPage(newPage);


            const keyword = props.obj && props.obj.name && props.obj.name !== '' ? `keyword=${encodeURI(props.obj.name)}` : '';
            const published = props.obj && props.obj.published !== null && props.obj.published !== -1 && props.obj.published !== 'null' ? `&published=${props.obj.published}` : '';
            const condition = props.obj && props.obj.conditionId && props.obj.conditionId !== 'null' && props.obj.conditionId !== -1 ? `&condition_id=${props.obj.conditionId}` : '';
            const category = props.obj && props.obj.categoryId && props.obj.categoryId !== 'null' && props.obj.categoryId !== -1 ? `&category_id=${props.obj.categoryId}` : '';
            const vendor = props.obj && props.obj.vendorId != null && props.obj.vendorId !== 'null' && props.obj.vendorId !== -1 ? `&vendor_id=${props.obj.vendorId}` : '';
            const brand = props.obj && props.obj.brand && props.obj.brand !== 'null' && props.obj.brand !== '' ? `&brand=${props.obj.published}` : '';
            const price_order = props.obj && props.obj.price_order && props.obj.price_order !== 'null' && (props.obj.price_order === 'asc' || props.obj.price_order === 'desc') ? `&price_order=${props.obj.price_order}` : '';
            const errors = props.obj && props.obj.errors && props.obj.errors !== 'null' && props.obj.errors !== -1 ? `&errors=${props.obj.errors}` : '';
            const products_per_page = props.obj && props.obj.products_per_page && props.obj.products_per_page !== 'null' ? `&products_per_page=${props.obj.products_per_page}` : '';
            const quantity = props.obj && props.obj.quantity != null && props.obj.quantity !== '' && !isNaN(Number(props.obj.quantity)) ? `&quantity=${props.obj.quantity}` : '';
            const quantity_min = props.obj && props.obj.quantity_min != null && props.obj.quantity_min !== '' && !isNaN(Number(props.obj.quantity_min)) ? `&quantity_min=${props.obj.quantity_min}` : '';
            const quantity_max = props.obj && props.obj.quantity_max != null && props.obj.quantity_max !== '' && !isNaN(Number(props.obj.quantity_max)) ? `&quantity_max=${props.obj.quantity_max}` : '';
            const endpoint = `${apiURL}/search/products?page=${page + 1}&${keyword + published + condition + category + vendor + brand + price_order + errors + products_per_page + quantity + quantity_min + quantity_max}`;



            const header = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8',
                },
            };

            const response = await fetch(endpoint, header);

            if (response.ok) {
                const json = await response.json();
                setTotalProducts(json.total);
                setTotalPages(json.last_page);
                setProducts(json);
            }
            setIsLoading(false);
        } catch (e) {
            console.error(e);
            setIsLoading(false);
        }
    }, [page, products, isLoading, props.obj]);

    const onPressGoToFirstPage = (event: any) => {
        goToPage(1);
    }

    const onPressGoToLastPage = (event: any) => {
        goToPage(totalPages);
    }

    const onPressBack = useCallback(async () => {
        try {
            setIsLoading(true);
            setPage((current) => current - 1);

            const keyword = props.obj && props.obj.name && props.obj.name !== '' ? `keyword=${encodeURI(props.obj.name)}` : '';
            const published = props.obj && props.obj.published !== null && props.obj.published !== -1 && props.obj.published !== 'null' ? `&published=${props.obj.published}` : '';
            const condition = props.obj && props.obj.conditionId && props.obj.conditionId !== 'null' && props.obj.conditionId !== -1 ? `&condition_id=${props.obj.conditionId}` : '';
            const category = props.obj && props.obj.categoryId && props.obj.categoryId !== 'null' && props.obj.categoryId !== -1 ? `&category_id=${props.obj.categoryId}` : '';
            const vendor = props.obj && props.obj.vendorId != null && props.obj.vendorId !== 'null' && props.obj.vendorId !== -1 ? `&vendor_id=${props.obj.vendorId}` : '';
            const brand = props.obj && props.obj.brand && props.obj.brand !== 'null' && props.obj.brand !== '' ? `&brand=${props.obj.published}` : '';
            const price_order = props.obj && props.obj.price_order && props.obj.price_order !== 'null' && (props.obj.price_order === 'asc' || props.obj.price_order === 'desc') ? `&price_order=${props.obj.price_order}` : '';
            const errors = props.obj && props.obj.errors && props.obj.errors !== 'null' && props.obj.errors !== -1 ? `&errors=${props.obj.errors}` : '';
            const products_per_page = props.obj && props.obj.products_per_page && props.obj.products_per_page !== 'null' ? `&products_per_page=${props.obj.products_per_page}` : '';
            const quantity = props.obj && props.obj.quantity != null && props.obj.quantity !== '' && !isNaN(Number(props.obj.quantity)) ? `&quantity=${props.obj.quantity}` : '';
            const quantity_min = props.obj && props.obj.quantity_min != null && props.obj.quantity_min !== '' && !isNaN(Number(props.obj.quantity_min)) ? `&quantity_min=${props.obj.quantity_min}` : '';
            const quantity_max = props.obj && props.obj.quantity_max != null && props.obj.quantity_max !== '' && !isNaN(Number(props.obj.quantity_max)) ? `&quantity_max=${props.obj.quantity_max}` : '';
            const endpoint = `${apiURL}/search/products?page=${page - 1}&${keyword + published + condition + category + vendor + brand + price_order + errors + products_per_page + quantity + quantity_min + quantity_max}`;

            const header = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8',
                },
            };
            const response = await fetch(endpoint, header);

            if (response.ok) {
                const json = await response.json();
                setTotalProducts(json.total);
                setTotalPages(json.last_page);
                setProducts(json);
            }
            setIsLoading(false);
        } catch (e) {
            console.error(e);
            setIsLoading(false);
        }
    }, [page, products, isLoading, props.obj]);

    // useEffect(() => {
    //     if (offerOnSearchName !== '') {
    //         const filteredList = filterByName(offersFetched, offerOnSearchName);
    //         setOffersFiltered(filteredList);
    //     } else setOffersFiltered(offersFetched);
    // }, [offerOnSearchName]);

    const handleOnclick = useCallback(
        async (sku: string) => {
            try {
                setIsLoading(true);
                await CTAs.cloneProduct(sku);
                setIsLoading(false);
            } catch (e) {
                console.error(e);
                setIsLoading(false);
            }
        },
        [isLoading]
    );

    useEffect(() => {
        if (RESPONSES.cloneProductResponse?.ok) {
            window.location.href = `/offers/${RESULTS.cloneProductResult.product.SKU}`;
        }
    }, [RESPONSES.cloneProductResponse, RESULTS.cloneProductResult]);

    const editPublish = (sku: string, isPublished: boolean) => {
        CTAs.editPublishProduct(sku!);
        setProducts((current: any) => ({
            ...current,
            data: current.data.map((item: any) => {
                if (item.SKU === sku) {
                    return {
                        ...item,
                        published: !isPublished,
                    };
                } else {
                    return item;
                }
            }),
        }));
        // console.log(RESULTS.editPublishProductResult);
    };

    const handleSelected = (isSelected: boolean, product: any) => {
        if (isSelected) {
            props.setSelectedProducts((current: any) => current.filter((e: any) => e.SKU !== product.SKU));
        } else {
            props.setSelectedProducts((current: any) => [...current, product]);
        }
    };

    const onFastEditClick = (data: any) => {
        if (fastEdit) {
            goToPage(page);
            setFastEdit(false);
            props.setFastEdit(false);
        } else {
            setFastEdit(true);
            props.setFastEdit(true);
        }
    };

    const onSelectAll=()=>{
        if(selectAll){
            setSelectAll(false);
            props.setSelectedProducts((current: any) => []);

        }else{
            setSelectAll(true);
            props.setSelectedProducts((current: any) => [...products.data]);

        }
        
    };

    const navigateToDetails = (sku: string) => {
        const queryParams = new URLSearchParams();

        if (props.obj.name && props.obj.name !== '') {
            queryParams.append('keyword', props.obj.name);
        }
        if (props.obj.conditionId && props.obj.conditionId !== 'null' && props.obj.conditionId !== -1) {
            queryParams.append('condition_id', props.obj.conditionId);
        }
        if (props.obj && props.obj.published !== null && props.obj.published !== -1 && props.obj.published !== 'null') {
            queryParams.append('published', props.obj.published);
        }
        if (props.obj.categoryId && props.obj.categoryId !== 'null' && props.obj.categoryId !== -1) {
            queryParams.append('category_id', props.obj.categoryId);
        }
        if (props.obj.vendorId != null && props.obj.vendorId !== 'null' && props.obj.vendorId !== -1) {
            queryParams.append('vendor_id', String(props.obj.vendorId));
        }
        if (props.obj.brand && props.obj.brand !== 'null' && props.obj.brand !== '') {
            queryParams.append('brand', props.obj.brand);
        }
        if (props.obj.price_order && props.obj.price_order !== 'null' && (props.obj.price_order === 'asc' || props.obj.price_order === 'desc')) {
            queryParams.append('price_order', props.obj.price_order);
        }
        if (props.obj.errors && props.obj.errors !== 'null' && props.obj.errors !== -1) {
            queryParams.append('errors', props.obj.errors);
        }
        if (props.obj.products_per_page && props.obj.products_per_page !== 'null') {
            queryParams.append('products_per_page', props.obj.products_per_page);
        }
        if (props.obj.quantity != null && props.obj.quantity !== '' && !isNaN(Number(props.obj.quantity))) {
            queryParams.append('quantity', String(props.obj.quantity));
        }
        if (props.obj.quantity_min != null && props.obj.quantity_min !== '' && !isNaN(Number(props.obj.quantity_min))) {
            queryParams.append('quantity_min', String(props.obj.quantity_min));
        }
        if (props.obj.quantity_max != null && props.obj.quantity_max !== '' && !isNaN(Number(props.obj.quantity_max))) {
            queryParams.append('quantity_max', String(props.obj.quantity_max));
        }
        queryParams.append('page', String(page));
        window.location.href = `offers/${sku}?${queryParams.toString()}`;
        // props.navigate(`${sku}?${queryParams.toString()}`);
    };



    const renderOffers =
        products.data?.length > 0 &&
        products.data?.map((offer: any, i: number) => {
            const hasNotes = typeof offer.notes === 'string' ? offer.notes.trim() !== '' && offer.notes.trim().toLowerCase() !== 'null' : Boolean(offer.notes);
            
            return (
                <div key={i} className={`offers-table-row ${hasNotes ? 'offers-table-row-has-notes' : ''}`}>

                    {!fastEdit ?

                        <div className='product-card'>
                            <input type='checkbox' checked={props.selectedProducts.some((e: any) => e.SKU === offer.SKU)} onChange={() => handleSelected(props.selectedProducts.some((e: any) => e.SKU === offer.SKU), offer)} />
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.title}</p>
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.category.name}</p>
                            {offer.pictures[0] ? <img style={{ width: 80, height: 80 }} src={offer.pictures[0].url} loading={'eager'} onClick={() => showDetailedImages(offer.pictures)} /> : <div style={{ width: 80, height: 80 }} />}
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.final_price}€</p>
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.waist} kg</p>
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.quantity}</p>
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.condition.name === 'FORPARTSORNOTWORKING' ? 'FORPARTS' : offer.condition.name}</p>
                            <OfferPopover offer={offer} />
                            <input disabled={true} type='checkbox' checked={offer.published ? true : false} onChange={() => editPublish(offer.SKU, offer.published)} />
                            <p onClick={() => navigateToDetails(offer.SKU)}>{offer.id}</p>
                        </div>

                        :

                        <FastEditRow
                            conditions={props.conditions}
                            offer={offer}
                            categories={props.categories}
                            setDetailedImages={setDetailedImages}
                            setPopupImages={setPopupImages}
                        />


                    }


                </div>
            );
        });

    return (
        <div className='offers-table'>
            <p>Total: {totalProducts}</p>
            <button
                            className='modal-button'
                            style={{
                                background: 'grey',
                                color: 'white',
                                margin: 0,
                                marginBottom: '20px',
                            }}
                            onClick={onSelectAll}
                        >
                            <p className='add-buttonText'>Select All</p>
                        </button>
            <div className='mainPagination'>
                {popupImages && (
                    <CustomModal setShow={setPopupImages} title='Dettaglio immagini' description={'Immagini del prodotto: '+detailedImages[0].product_sku} ctaTtitle='Chiudi' ctaFunction={closeDetailedImages}>
                        <div>
                            <SimpleImageSlider
                                width={768}
                                height={576}
                                images={detailedImages}
                                showBullets={true}
                                showNavs={true}
                            />
                        </div>
                    </CustomModal>
                )}
                {
                    user && user !== null && user !== undefined && user.roles?.find((e: any) => e.role === possible_statuses.userType.admin) ?

                        <button
                            className='modal-button'
                            style={{
                                background: 'orange',
                                color: 'white',
                                margin: 0,
                                marginBottom: '20px',
                            }}
                            onClick={onFastEditClick}
                        >
                            <p className='add-buttonText'>Fast Edit</p>
                        </button>

                        :


                        <div></div>

                }

                <div className='mainPaginationPages'>
                    {Array.from(Array(totalPages + 1).keys()).filter(p => p <= Math.min(totalPages, page + 4) && p >= Math.max(1, page - 4)).map((currentPage) => (
                        <button key={currentPage} onClick={() => goToPage(currentPage)} style={{ color: page === currentPage ? '#6788a1' : 'hsl(0, 0%, 70%)' }}>
                            {currentPage}
                        </button>
                    ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 30, margin: '20px auto' }}>
                    <button className='modal-button' style={{ margin: 0 }} onClick={onPressGoToFirstPage}>
                        <p className='add-buttonText'>start</p>
                    </button>
                    {products.prev_page_url !== null ? (
                        <button className='modal-button' style={{ margin: 0 }} onClick={onPressBack}>
                            <p className='add-buttonText'>Indietro</p>
                        </button>
                    ) : (
                        <button className='modal-button' style={{ margin: 0, height: 0, opacity: 0, pointerEvents: 'none' }}></button>
                    )}
                    <p className='add-buttonText' style={{ color: 'black' }}>
                        Pagina {page} di {products.last_page}
                    </p>
                    {products.next_page_url !== null ? (
                        <button className='modal-button' style={{ margin: 0 }} onClick={onPressNext}>
                            <p className='add-buttonText'>Avanti</p>
                        </button>
                    ) : (
                        <button className='modal-button' style={{ margin: 0, height: 0, opacity: 0, pointerEvents: 'none' }}></button>
                    )}
                    <button className='modal-button' style={{ margin: 0 }} onClick={onPressGoToLastPage}>
                        <p className='add-buttonText'>end</p>
                    </button>
                </div>
            </div>
            <div className='product-table-fields'>
                <div style={{ display: 'flex' }}>
                    <p className='field-label'></p>
                </div>
                <div
                    style={{
                        display: 'flex',
                        width: isMobile ? '174px' : '',
                        marginLeft: isMobile ? '0' : '',
                    }}
                >
                    <p className='field-label'>Nome</p>
                </div>
                {!isMobile && (
                    <>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Categoria</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Immagini</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Prezzo</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Peso</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Quantità</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Condizione</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Errori</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Pubblicato</p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p className='field-label'>Id</p>
                        </div>
                    </>
                )}
            </div>
            <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
            {products.data?.length > 0 && !isLoading ? (
                <div className='offers-table-results scrollable-element'>{renderOffers}</div>
            ) : products.data?.length === 0 && !isLoading ? (
                <p>Nessun prodotto trovato.</p>
            ) : (
                <Loader />
            )}

            <div className='mainPagination' style={{ marginTop: 20 }}>
                <div className='mainPaginationPages'>
                    {getPages().map((currentPage) => (
                        <button key={currentPage} onClick={() => goToPage(currentPage)} style={{ color: page === currentPage ? '#6788a1' : 'hsl(0, 0%, 70%)' }}>
                            {currentPage}
                        </button>
                    ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 30, margin: '20px auto' }}>
                    {products.prev_page_url !== null ? (
                        <button className='modal-button' style={{ margin: 0 }} onClick={onPressBack}>
                            <p className='add-buttonText'>Indietro</p>
                        </button>
                    ) : (
                        <button className='modal-button' style={{ margin: 0, height: 0, opacity: 0, pointerEvents: 'none' }}></button>
                    )}
                    <p className='add-buttonText' style={{ color: 'black' }}>
                        Pagina {page} di {products.last_page}
                    </p>
                    {products.next_page_url !== null ? (
                        <button className='modal-button' style={{ margin: 0 }} onClick={onPressNext}>
                            <p className='add-buttonText'>Avanti</p>
                        </button>
                    ) : (
                        <button className='modal-button' style={{ margin: 0, height: 0, opacity: 0, pointerEvents: 'none' }}></button>
                    )}
                </div>
            </div>
        </div>
    );
};
export default OffersTable;
